import { useEffect, type ReactNode } from "react";
import { Outlet, useLocation } from "react-router-dom";
import SiteNavbar from "./SiteNavbar";
import SiteFooter from "./SiteFooter";

export default function SiteLayout({ children }: { children?: ReactNode }) {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SiteNavbar />
      <main className="flex-1 w-full">{children ?? <Outlet />}</main>
      <SiteFooter />
    </div>
  );
}